export const ENERGY_CONSUMPTION_CHART_WIDGET_NAMESPACE = 'widget.energy-consumption-chart'
